import React from 'react';
import { Modal } from 'shared/Modal';
import { Button } from 'shared/Button/NewButton';
import { css } from 'emotion';
import { useT } from 'client/i18n/hooks/useT';

export const UnsupportedFileModal = ({
  hideModal,
}: {
  hideModal: () => void;
}) => {
  const t = useT();
  return (
    <Modal
      labelledBy="unsupportedFileModalTitle"
      isShowing={true}
      isShowingCloseButton={true}
      onClickClose={hideModal}
      onClickOutside={hideModal}
      renderContent={() => (
        <div
          className={css`
            text-align: center;
          `}
        >
          <h4
            id="unsupportedFileModalTitle"
            className={css`
              margin-bottom: 16px;
            `}
          >
            {t(
              'EpisodeOptionsScreen.EpisodeContent.UnsupportedFileModal.Title',
              'Unsupported file',
              'Unsupported file notification modal title'
            )}
          </h4>
          <p
            className={css`
              margin-bottom: 16px;
            `}
          >
            {t(
              'EpisodeOptionsScreen.EpisodeContent.UnsupportedFileModal.Message',
              'This file format cannot be uploaded.',
              'Unsupported file notification modal message'
            )}
          </p>
          <Button color="purple" onClick={hideModal}>
            {t('Button.GotIt', 'Got it', 'Dismiss button text')}
          </Button>
        </div>
      )}
    />
  );
};
